<template>
  <section class="property">
    <div class="inner">
      <div class="back">
        <page-link to="/our-developments">
          <font-awesome-icon icon="chevron-left" />Back to development list
        </page-link>
      </div>

      <div class="right">
        <h1>
          {{ page.street }}, {{ page.area }}
          <span class="price" v-if="page.key_features">{{ page.key_features }}</span>
        </h1>

        <a @click.prevent="scrolldown()" class="enquire" href>
          <img alt="Enquire" src="../assets/pulse.png" /> Enquire about this development
        </a>

        <div class="social">
          <social-sharing
            :description="page.bedrooms + ' Bedroom ' + page.build_type + ' in ' + page.street + ', ' + page.area"
            inline-template
            title="Property for sale with LMH Estates"
            url="#"
          >
            <div class="share">
              <network network="email">
                <font-awesome-icon icon="envelope" />
              </network>
              <network network="facebook">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook' }" />
              </network>
              <network network="twitter">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'twitter' }" />
              </network>
              <network network="whatsapp">
                <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'whatsapp' }" />
              </network>
            </div>
          </social-sharing>
        </div>

        <div class="links" v-if="page.floor_plans && page.floor_plans.length > 0">
          <a :href="file.File" :key="file._id" target="_blank" v-for="file in page.floor_plans">
            <font-awesome-icon icon="map" />
            {{ file.name }}
          </a>
        </div>

        <iframe
          :src="
            'https://www.google.com/maps/embed/v1/search?q=' +
              encodeURIComponent(mapAddress) +
              '&key=AIzaSyBKCUxnqyzcUY92lydH_9IphBKn-hKL4wA'
          "
          allowfullscreen
          class="map"
          frameborder="0"
          height="250"
          style="border:0"
          width="100%"
        ></iframe>
      </div>

      <div class="left">
        <div class="images">
          <div class="corner-ribbon">
            {{
              page.status == "Sold" || page.status == "Let By" || page.status == "Under Offer"
                ? page.status
                : page.highlight_text
            }}
          </div>

          <img
            :alt="page.street + ', ' + page.area"
            :src="page.images[0].image"
            id="mainimage"
            v-if="page.images && page.images.length"
          />

          <div class="thumbnails">
            <a :key="image._id" @click.prevent="switchImage(image.image)" href v-for="image in page.images">
              <img :alt="page.street + ', ' + page.area" :src="image.image" />
            </a>
          </div>
        </div>

        <div class="description" v-html="page.description" v-if="page.description"></div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex"
import wNumb from "wnumb"
var mformat = wNumb({
  decimals: 0,
  thousand: ",",
  prefix: "£"
})

var VueScrollTo = require("vue-scrollto")

var options = {
  container: "body",
  easing: "ease-in",
  offset: 0,
  force: true,
  cancelable: true,
  onStart: function() {
    // scrolling started
  },
  onDone: function() {
    // scrolling is done
  },
  onCancel: function() {
    // scrolling has been interrupted
  },
  x: false,
  y: true
}

export default {
  computed: {
    ...mapState(["page"]),
    mapAddress() {
      if (!this.page) return ""
      return [this.page.postcode].join(", ")
    }
  },
  methods: {
    switchImage(src) {
      document.getElementById("mainimage").src = src
    },
    scrolldown() {
      VueScrollTo.scrollTo("#form", 500, options)
    },
    formatPrice(val) {
      if (typeof val == "number") return mformat.to(val)
      else return mformat.to(Number(val))
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.property {
  padding: 3rem 0;
  padding-bottom: 6rem;
}

.back {
  padding-bottom: 3rem;
}

.back svg {
  color: #d1ae54;
  margin-right: 0.5rem;
  transition: all 0.2s;
}

.back:hover svg {
  margin-right: 1rem;
}

.map {
  margin-top: 3rem;
}

.enquire {
  display: block;
  padding: 1rem 2rem;
  background: #d1ae54;
  font-weight: bold;
  transition: all 0.2s;
}

.enquire:hover {
  transform: scale(1.05);
}

.enquire img {
  vertical-align: middle;
  margin-right: 1rem;
  height: 22px;
  opacity: 0.5;
}

.images {
  position: relative;
  overflow: hidden;
}

#mainimage {
  width: 100%;
}

.thumbnails {
  line-height: 0;
}

.thumbnails a {
  width: 10%;
  height: 7rem;
  display: inline-block;
  overflow: hidden;
}

.thumbnails img {
  min-height: 100%;
  min-width: 100%;
  transition: all 0.2s;
}

.thumbnails a:hover img {
  transform: scale(1.1);
  filter: brightness(1.2);
}

h1 {
  background: #253e52;
  color: white;
  font-weight: normal;
  padding: 1rem 2rem;
  font-size: 3rem;
}

h2 {
  background: #d1ae54;
  color: #253e52;
  font-weight: normal;
  padding: 1rem 2rem;
  font-size: 1.8rem;
}

.social {
  background: #f7f7f7;
  color: #253e52;
  font-weight: normal;
  padding: 1.5rem 2rem;
  font-size: 2rem;
}

.price {
  display: block;
  color: #d1ae54;
  font-size: 2rem;
}

.share {
  text-align: right;
}

.share >>> span {
  cursor: pointer;
  margin-right: 1rem;
}
.share >>> svg {
  transition: all 0.2s;
}

.share >>> svg:hover {
  transform: scale(1.1);
}

.share >>> .fa-envelope {
  color: #666;
}

.share >>> .fa-facebook {
  color: #3a559f;
}

.share >>> .fa-twitter {
  color: #1caadd;
}

.share >>> .fa-whatsapp {
  color: #1bd741;
}

.description {
  line-height: 1.5;
}

.description >>> p {
  margin-top: 1rem;
}

.features {
  border-left: 1px solid #f7f7f7;
  border-right: 1px solid #f7f7f7;
  padding: 2rem;
  padding-top: 0;
}

.features >>> ul li {
  margin-bottom: 0.5rem;
}

.corner-ribbon {
  width: 200px;
  position: absolute;
  background: #e43;
  top: 25px;
  right: -50px;
  left: auto;
  text-align: center;
  line-height: 50px;
  color: #fff;
  transform: rotate(45deg);
  -webkit-transform: rotate(45deg);
  font-size: 1rem;
}

.links {
  padding-top: 2rem;
  border: 1px solid #f7f7f7;
  padding: 2rem;
  padding-bottom: 1rem;
  margin-top: 3rem;
}

.links a {
  display: block;
  margin-bottom: 1rem;
}

.links a svg {
  margin-right: 0.5rem;
  width: 2rem;
}

.fa-file-pdf {
  color: #e73e33;
}

.fa-map {
  color: #a6e643;
}

@media screen and (max-width: 780px) {
  .thumbnails a {
    width: 20%;
  }
}
</style>
